import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ConfigBaseFilter, ConfigService, ListLayout, ListLayoutMultipleComponent, ListSortOption, SkeletonLoaderLayout } from 'gung-list';
import { combineLatest, Observable, startWith, switchMap } from 'rxjs';
import { CustomerDocumentsTableListComponent } from '../../components/customer-documents-table-list/customer-documents-table-list.component';
import { CustomerDocumentsService, DocumentRelation } from '../customer-documents/customer-documents.service';
import { SelectedCustomerService } from '../selected-customer/selected-customer.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerDocumentsListConfigService implements ConfigService<DocumentRelation> {
  protected customerDocumentsService = inject(CustomerDocumentsService);
  protected selectedCustomerService = inject(SelectedCustomerService);
  
  topFilter = true;
  skeletonLoaderLayout: SkeletonLoaderLayout = 'table';

  getItems(route?: ActivatedRouteSnapshot): Observable<DocumentRelation[]> {
    return combineLatest([
      this.selectedCustomerService.getSelectedCustomer(),
      this.customerDocumentsService.documentsUpdated.pipe(startWith(null))
    ]).pipe(
      switchMap(([customer]) => {
        return this.customerDocumentsService.getDocuments(`customer:${customer.id}`, true);
      })
    )
  }

  getFilters(route?: ActivatedRouteSnapshot): ConfigBaseFilter<DocumentRelation>[] {
    return [];
  }

  getSortOptions(route?: ActivatedRouteSnapshot): ListSortOption<DocumentRelation>[] {
    return [];
  }

  getBatchSizes(route?: ActivatedRouteSnapshot): number[] | undefined {
    return [100];
  }

  getLayouts(route?: ActivatedRouteSnapshot): ListLayout<DocumentRelation>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => CustomerDocumentsTableListComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'Documents list'
      }
    ];
  }

  getSearchTerms(item: DocumentRelation): string[] {
    return [item.id];
  }

  getItemId(item: DocumentRelation): string {
    return item.id;
  }

  getNothingFoundTranslateTag(): string {
    return 'NOTHING_FOUND_DOCUMENTS_GUNG'
  }
}
